export const reorderArray = (arr, sourceIndex, destinationIndex) => {
  // Create a shallow copy of the original array to avoid mutating it
  const newArr = [...arr];

  // Remove the element from the source index
  const [removedElement] = newArr.splice(sourceIndex, 1);

  // Insert the element at the destination index
  newArr.splice(destinationIndex, 0, removedElement);

  // Return the new array with the updated order
  return newArr;
};